import styled from 'styled-components';
import media from 'src/styles/Media.styled';

export const Container = styled.div`
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
`;
export const RemovePoText = styled.div`
    font-size: 13px;
    color: #1010eb;
    font-family: AvenirNextWorld Demi;
    cursor: pointer;
    margin-left: 10px;
    ${media.smalDevice`
        margin-right: 5px;
        margin-left: 0px;
    `}
    ${media.mobileDevice`
        text-align:${({ mbTextAlign }) => mbTextAlign};
    `}
`;
